module.exports = __webpack_public_path__ + "static/service-section-img-97bcf2ac5ad3ac3e12374e53fd5ecbb4.webp";